import { PostWithAccessToken } from "../../../helpers/http";

export const GetCaseFormListData = async (data) => {
  return (
    await PostWithAccessToken(
      `${process.env.REACT_APP_DOCTOR_API_URL}GenericForm/CaseFormListData`,
      data
    )
  ).json();
};

export const SaveCaseFormData = async (data) => {
  return (
    await PostWithAccessToken(
      `${process.env.REACT_APP_DOCTOR_API_URL}GenericForm/SaveCaseFormData`,
      data
    )
  ).json();
};